'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCloseThreadMessage = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isCloseThreadMessage = exports.isCloseThreadMessage = (0, _isType.isType)(_messageTypes.CLOSE_THREAD);